/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { List, Segment, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import config from '@plone/volto/registry';
import footerLogo from 'volto-deba/../theme/site/assets/images/logo_footer.png';
import { useGoogleAnalytics } from 'volto-google-analytics';
import messages from 'volto-deba/components/Utils/overrideMessages.js';

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  const { settings } = config;
  const lang = useSelector((state) => state.intl.locale);
  const subsite = useSelector((state) => state.subsite?.data);
  return (
    <Segment role="contentinfo" vertical padded textAlign="center" id="footer">
      <Segment basic className="discreet">
        <Image
          bordered
          centered
          src={footerLogo}
          alt={intl.formatMessage(messages.debaTown)}
          title={intl.formatMessage(messages.debaTown)}
          width="88px"
          height="89px"
        />
        {!subsite ? (
          <>
            <p>Portu kalea 1, 20820 Deba.</p>
            <p>
              {intl.formatMessage(messages.phone)}: 943 192 840 |{' '}
              {intl.formatMessage(messages.fax)}: 943 192 894
            </p>
            <p>© Debako Udala. IFK P2003000C</p>
          </>
        ) : (
          <>
            <p>
              {intl.formatMessage(messages.office)}: Ifar Kalea, 4, 20820 Deba.
            </p>
            <p>
              {intl.formatMessage(messages.phone)}: 943 19 24 52 |{' '}
              <a href={intl.formatMessage(messages.writeToTownUrl)}>
                {intl.formatMessage(messages.writeToTown)}
              </a>
            </p>
          </>
        )}
      </Segment>
      <Segment basic className="utilities">
        <List horizontal>
          {/* wrap in div for a11y reasons: listitem role cannot be on the <a> element directly */}
          <div role="listitem" className="item">
            <Link
              className="item"
              to={`/${lang}/${intl.formatMessage(messages.siteMapUrl)}`}
            >
              {intl.formatMessage(messages.siteMap)}
            </Link>
          </div>
          <div role="listitem" className="item">
            {!subsite && (
              <Link
                className="item"
                to={`${intl.formatMessage(messages.contactUrl)}`}
              >
                {intl.formatMessage(messages.contact)}
              </Link>
            )}
          </div>
          <div role="listitem" className="item">
            <Link
              className="item"
              to={`/${lang}/${intl.formatMessage(messages.privacyUrl)}`}
            >
              {intl.formatMessage(messages.privacy)}
            </Link>
          </div>
        </List>
      </Segment>
    </Segment>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
